import { useEffect, useState } from 'react';
import api from '../api';
import { resolvePhotoUrl } from '../photoUrl';

/*
 * Where the offline navigation data is (GET /map/offline,
 * routes/map_points.py): the routing graph's pointer and the base map's.
 * Asked once per page; the answer is kept on the device, so a phone that
 * opens the map with no signal still finds the files it already has.
 * A desktop's loopback URLs are re-based onto the server this client talks
 * to (utils/photoUrl.js), as photographs are.
 */
const KEY = 'mb_offline_pointers';
let pending = null;

function kept() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || 'null');
  } catch (e) {
    return null;
  }
}

function resolved(data) {
  if (!data) return null;
  const out = { attribution: data.attribution || '© OpenStreetMap contributors' };
  for (const name of ['routing', 'basemap']) {
    const entry = data[name];
    out[name] = entry && entry.available !== false && entry.pointer_url
      ? { pointerUrl: resolvePhotoUrl(entry.pointer_url) } : null;
  }
  return out;
}

export async function fetchOfflinePointers() {
  if (!pending) {
    pending = api.get('/map/offline')
      .then(({ data }) => {
        try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) { /* nothing kept */ }
        return resolved(data);
      })
      .catch(() => resolved(kept()));
  }
  return pending;
}

export function useOfflinePointers(enabled = true) {
  const [pointers, setPointers] = useState(() => resolved(kept()));
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    fetchOfflinePointers().then((p) => { if (live && p) setPointers(p); });
    return () => { live = false; };
  }, [enabled]);
  return pointers;
}

/** For tests. */
export function resetOfflinePointers() {
  pending = null;
}
